import { environment } from "src/environments/environment";

export class ConfiguracionSolicitar {
    public lstCentroCosto: any[];
    public lsTipoPago: any[];
    public lstTipoServicio: any[];
    public lstTipoClienteEncargo: any[];


    public truncarTotalServicio: boolean;
    public retornoHorario: boolean;
    public retornoUltimoDestino: boolean;
    public referenciaDestino: boolean;
    public instruccionDestino: boolean;
    public contactoAdicional: boolean;
    public emitirFactura: boolean;
    public aeropuertoOpcionNacionalInter: boolean;
    public aeropuertoDetalleVuelo: boolean;
    public seleccionarTipoPagoDefecto: boolean;
    public seleccionarTipoServicioDefecto: boolean;
    public seleccionarCentroCostoDefecto: boolean;
    public tipoVehiculo: string;
    public centroCostoEditable: boolean = true;
    public clienteCargo: boolean;
    public peditParaOtros: boolean = true;
    public pedirOtrosPersonal: boolean = true;
    public pedirOtrosVisita: boolean = true;
    public servicioTipoRutina: boolean;
    public listaCodigoPromocional: boolean;
    public modalValidacionServicioASolicitar: boolean;
    public cobrarUltimoDestinoComoPrimerDestino: boolean;
    constructor() {
    }
}

export const tiposVechiculos = {
    MOTO: "MOTO",
    AUTO: "AUTO"
}